module.exports = __webpack_public_path__ + "static/media/ObjImage2.34309652.png";